import { useParams, generatePath, Outlet } from 'react-router-dom';
import { PermissionDenied, PermissionEnum, IconLoader, Tabs } from '@ui/src';
import { useAppSelector } from '@store';
import { OrganizationType } from '../types';
import useExternalIntegration from './hooks/use-external-integration';

import ROUTES from '../../../routes';

import cn from './styles.module.css';
import commonStyles from '../common.module.css';

const ExternalAccounts = ({ type }: { type: OrganizationType }) => {
  const { casp } = useAppSelector((state) => state.customersDictionaries);
  const { pspPartners, openPayNotificationVisible, pspIntegrations } =
    useAppSelector((state) => state.customersExternalAccounts);
  const { activePermissions } = useAppSelector((state) => state.root);

  const { customerId } = useParams();

  useExternalIntegration({
    activePermissions,
    pspIntegrations,
    pspPartners,
    casp,
    customerId,
    type,
  });

  let content = <div />;

  if (
    activePermissions &&
    !activePermissions.includes(PermissionEnum.PSP_INTEGRATION_ACCOUNT_LIST) &&
    !activePermissions.includes(
      PermissionEnum.CUSTOMERS_EXTERNAL_ORGANIZATIONS_LIST,
    )
  ) {
    content = <PermissionDenied />;
  } else if (
    activePermissions &&
    (activePermissions?.includes(PermissionEnum.PSP_INTEGRATION_ACCOUNT_LIST) ||
      activePermissions.includes(
        PermissionEnum.CUSTOMERS_EXTERNAL_ORGANIZATIONS_LIST,
      ))
  ) {
    content = (
      <div className={cn.externalAccounts}>
        <div className={cn.externalAccountsTop}>
          <div className={cn.externalAccountsTopTitle}>
            External Integration
          </div>
          {activePermissions.includes(
            PermissionEnum.CUSTOMERS_EXTERNAL_ORGANIZATIONS_LIST,
          ) &&
            activePermissions.includes(
              PermissionEnum.PSP_INTEGRATION_ACCOUNT_LIST,
            ) && (
              <Tabs
                wrapperClassName={cn.externalAccountsTabs}
                tabs={[
                  {
                    name: 'Accounts',
                    path: generatePath(
                      type === OrganizationType.INDIVIDUAL
                        ? ROUTES.CUSTOMERS_INDIVIDUAL_EXTERNAL_ACCOUNTS_LIST
                        : ROUTES.CUSTOMERS_CORPORATE_EXTERNAL_ACCOUNTS_LIST,
                      { customerId: customerId as string },
                    ),
                  },
                  {
                    name: 'Linked Customers',
                    path: generatePath(
                      type === OrganizationType?.INDIVIDUAL
                        ? ROUTES.CUSTOMERS_INDIVIDUAL_EXTERNAL_LINKED_CLIENTS
                        : ROUTES.CUSTOMERS_CORPORATE_EXTERNAL_LINKED_CLIENTS,
                      { customerId: customerId as string },
                    ),
                  },
                ]}
                enableRouting
              />
            )}
        </div>
        <Outlet />
        {openPayNotificationVisible && (
          <div className={commonStyles.reportNotification}>
            <div className={commonStyles.reportNotificationLeft}>
              <IconLoader />
              <div className={commonStyles.reportText}>
                Account will be created soon
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return content;
};

export default ExternalAccounts;
